import Loadable from '../../components/loadable';

const FetchEzidebitPaymentDetailsModal = Loadable({
  loader: () => import('../../pages/invoices/fetch_ezidebit_payment_details_modal'),
  type: 'modal',
});

angular.module('gym').value('FetchEzidebitPaymentDetailsModal', FetchEzidebitPaymentDetailsModal);
